<template>
  <div class="basic-label ri-label" :style="{background: backgroundColor}">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BasicLabel',
  props: {
    backgroundColor: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@riseupil/base-ui/src/scss/riseup-colors";

.basic-label {
  width: 100%;
  padding: 10px 8px;
  border-radius: 8px;
  display: inline-block;
  direction: rtl;
}
</style>
